/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../axios'
import { resolve } from 'core-js/fn/promise'
import router from "@/router";

export default {
  // Sanctum
  loginSanctum ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sanctum/csrf-cookie')
        .then(response => {
          axios.post('/login', payload)
            .then(response => {
              commit('SET_LOGGED_USER', response.data.data)
              resolve(response)
            })
            .catch(error => { reject(error) })
        })
        .catch(error => { reject(error) })
    })
  },

  registerUserSanctum ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/register', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          payload.notify
          reject(error)
        })
    })
  },

  logoutSanctum ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post('/logout')
        .then(response => {
          commit('SET_LOGGED_OUT')
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  getLoggedInUser ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/me')
        .then(response => {
          commit('SET_LOGGED_USER', response.data.data)
          resolve(response)
        })
        .catch(error => {
          // if(error.response && error.response.status === 401) {
          //   router.push('/pages/login')
          // }
          reject(error) })
    })
  },

  updateLoggedInUser ({ commit },  payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/me', payload)
        .then(response => {
          commit('SET_LOGGED_USER', response.data.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  sendPasswordResetLink ({comit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/password/request', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  resetPassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/password/reset', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  }
}
